// extracted by mini-css-extract-plugin
export var explainable = "_fs-a";
export var printerCard = "_fs-1";
export var printerCardConfigured = "_fs-2";
export var printerCardError = "_fs-3";
export var printerCardsContainer = "_fs-0";
export var printerIcon = "_fs-8";
export var printerIconConfigured = "_fs-5";
export var printerIconContainer = "_fs-4";
export var printerIconError = "_fs-6";
export var printerIconUnconfigured = "_fs-7";
export var workstationsTableCard = "_fs-9";